import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

import reducers from './reducers';
import { authTransform } from './transforms';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
  transforms: [authTransform],
};

const asyncDispatchMiddleware = (store) => (next) => (action) => {
  let syncActivityFinished = false;
  let actionQueue = [];

  function flushQueue() {
    actionQueue.forEach((a) => store.dispatch(a));
    actionQueue = [];
  }

  function asyncDispatch(asyncAction) {
    actionQueue = actionQueue.concat([asyncAction]);

    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const actionWithAsyncDispatch = { ...action, asyncDispatch };

  next(actionWithAsyncDispatch);
  syncActivityFinished = true;
  flushQueue();
};

const persistedReducer = persistReducer(persistConfig, reducers);

const getMiddlewares = () => {
  const middlewares = [thunk];

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(
      createLogger({
        duration: true,
        diff: true,
      }),
    );
  }

  middlewares.push(asyncDispatchMiddleware);
  return middlewares;
};

const configureStore = (initialState = {}) => {
  const middleware = applyMiddleware(...getMiddlewares());
  const store = createStore(persistedReducer, initialState, middleware);
  const persistor = persistStore(store);
  return { store, persistor };
};

export default configureStore();
